export default __webpack_public_path__ + "static/media/logo.217348d7.webp";